(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-CO');

  /* Menú móvil y búsqueda */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-toggle]');
    if (!toggle) return;
    const target = document.getElementById(toggle.dataset.toggle);
    if (!target) return;
    const open = target.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
    if (open) { const input = $('input', target); if (input) input.focus(); }
  });

  /* Paneles laterales */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = $('button, a, input', d.querySelector('.drawer__panel'));
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* Carrito AJAX */
  async function refreshCart(open) {
    try {
      const res = await fetch(root + '?sections=cart-drawer');
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('#CartDrawer .drawer__panel');
      const current = $('#CartDrawer .drawer__panel');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const cart = await (await fetch(root + 'cart.js')).json();
      $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
      if (open) openDrawer('CartDrawer');
    } catch (err) {
      window.location.href = root + 'cart';
    }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.js-ajax-add');
    if (!form || !$('#CartDrawer')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const err = await res.json();
        alert(err.description || 'No pudimos agregar este producto.');
      } else {
        await refreshCart(true);
      }
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    btn.disabled = true;
    await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.quantity) }),
    });
    if ($('#CartDrawer.is-open')) await refreshCart(false);
    else window.location.reload();
  });

  /* Carrusel */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-scroll]');
    if (!b) return;
    const track = document.getElementById(b.dataset.target);
    if (track) track.scrollBy({ left: Number(b.dataset.scroll) * (track.clientWidth * 0.8), behavior: 'smooth' });
  });

  /* Filtros: enviar al cambiar */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[data-auto-submit]');
    if (form && e.target.type !== 'number') form.submit();
  });

  /* Producto */
  $$('[data-product]').forEach((wrap) => {
    const variants = JSON.parse(($('[data-variants]', wrap) || {}).textContent || '[]');
    const idInput = $('input[name="id"]', wrap);
    const qtyInput = $('input[name="quantity"]', wrap);
    const priceEl = $('[data-price]', wrap);
    const compareEl = $('[data-compare]', wrap);
    const addBtn = $('[data-add-btn]', wrap);
    const mainImg = $('.js-main-image', wrap);
    let variant = variants.find((v) => String(v.id) === (idInput && idInput.value)) || variants[0];

    function paintBundles() {
      if (!variant) return;
      $$('[data-bundle]', wrap).forEach((b) => {
        const n = Number(b.dataset.bundle);
        const small = $('small', b);
        if (small) small.textContent = money(variant.price * n);
      });
    }
    function paint() {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) compareEl.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        const label = $('[data-add-label]', addBtn);
        if (label) label.textContent = variant.available ? addBtn.dataset.available : 'Producto agotado';
      }
      if (variant.featured_image && mainImg) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = variant.featured_image;
        const base = variant.featured_image.split('?')[0].replace(/^https?:/, '');
        $$('[data-thumb]', wrap).forEach((t) => {
          const on = t.dataset.src.split('?')[0].replace(/^https?:/, '') === base;
          t.setAttribute('aria-pressed', on);
          if (on) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.offsetLeft - 12, behavior: 'smooth' });
        });
      }
      paintBundles();
    }

    $$('[data-option]', wrap).forEach((sel) =>
      sel.addEventListener('change', () => {
        const chosen = $$('[data-option]', wrap).map((s) => s.value);
        const found = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        if (found) { variant = found; paint(); }
      })
    );

    $$('[data-bundle]', wrap).forEach((b) =>
      b.addEventListener('click', () => {
        $$('[data-bundle]', wrap).forEach((x) => x.setAttribute('aria-checked', 'false'));
        b.setAttribute('aria-checked', 'true');
        if (qtyInput) qtyInput.value = b.dataset.bundle;
      })
    );

    $$('[data-thumb]', wrap).forEach((t) =>
      t.addEventListener('click', () => {
        $$('[data-thumb]', wrap).forEach((x) => x.setAttribute('aria-pressed', 'false'));
        t.setAttribute('aria-pressed', 'true');
        if (mainImg) { mainImg.src = t.dataset.src; mainImg.removeAttribute('srcset'); }
      })
    );
    paint();
  });

  /* Pestañas */
  $$('[data-tabs]').forEach((tabs) => {
    const btns = $$('[role="tab"]', tabs);
    btns.forEach((btn) =>
      btn.addEventListener('click', () => {
        btns.forEach((b) => {
          const on = b === btn;
          b.setAttribute('aria-selected', on);
          document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
        });
      })
    );
  });
})();
